export const tocHide = () => {
    const ele = document.getElementById('toc-trigger');
    if (ele) {
        ele.style.display = 'none';
    }
};
export const tocShow = () => {
    const ele = document.getElementById('toc-trigger');
    if (ele) {
        ele.style.display = '';
    }
};
